import { h, mount } from '../lib/dom.js';
import { login } from '../lib/auth.js';
import { navigate } from '../lib/router.js';
import { toast } from '../lib/ui.js';

export function renderLogin({ outlet }) {
  const emailInput = h('input', {
    class: 'input', type: 'email', name: 'email', autocomplete: 'username',
    required: true, placeholder: 'e-posta',
  });
  const passInput = h('input', {
    class: 'input', type: 'password', name: 'password', autocomplete: 'current-password',
    required: true, placeholder: '••••••••',
  });
  const submitBtn = h('button', { class: 'btn btn-primary', type: 'submit' }, 'Oturum aç');
  const errBox = h('p', { class: 'error', style: { display: 'none', color: 'var(--status-failed)' } });

  const form = h('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      errBox.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Giriş yapılıyor…';
      try {
        const user = await login(emailInput.value.trim(), passInput.value);
        toast('Hoş geldin ' + (user.name || ''), { type: 'success' });
        navigate(user.role === 'coach' ? '/coach' : '/student', { replace: true });
      } catch (err) {
        errBox.textContent = err.message || 'Giriş başarısız.';
        errBox.style.display = 'block';
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Oturum aç';
      }
    },
    class: 'stack stack-lg',
  },
    h('div', { class: 'field' }, h('label', { for: 'email' }, 'E-posta'), emailInput),
    h('div', { class: 'field' }, h('label', { for: 'password' }, 'Parola'), passInput),
    errBox,
    submitBtn,
  );

  const card = h('div', { class: 'login-card' },
    h('div', { class: 'login-brand' }, 'Sessiz Kütüphane', h('small', {}, 'Koçluk & Plan')),
    h('p', { class: 'login-tag' }, 'Bir haftanın omurgası, tek bir yerde.'),
    form,
  );

  mount(outlet, h('div', { class: 'login-shell' }, card));
  setTimeout(() => emailInput.focus(), 40);
}
